import { Percent } from 'lucide-react';
import { cn } from 'src/lib/utils';
import DateRangeModal from '../date-range-modal';
import { OverviewDateFilterType } from '../../utils/overview-date-range';

interface OverviewBetaControlsProps {
  dateFilter: OverviewDateFilterType;
  editMode: boolean;
  onDateChange: (dateFilter: string, startDate?: string, endDate?: string) => void;
  onEditToggle: () => void;
}

const DATE_CHIPS: Array<{ id: OverviewDateFilterType; label: string }> = [
  { id: 'last_week', label: 'Last week' },
  { id: 'last_month', label: 'Last month' },
  { id: 'this_month', label: 'This month' },
];

export function OverviewBetaControls({
  dateFilter,
  editMode,
  onDateChange,
  onEditToggle,
}: OverviewBetaControlsProps) {
  return (
    <div className="mb-6 flex flex-wrap items-center gap-2.5">
      <button
        type="button"
        onClick={onEditToggle}
        className={cn(
          'inline-flex items-center gap-1.5 rounded-full border-[1.5px] px-3.5 py-1.5 text-[12.5px] font-semibold transition-all',
          editMode
            ? 'border-[#2563EB] bg-[#EFF6FF] text-[#2563EB]'
            : 'border-[#D9DBE3] bg-white text-[#5E6278] hover:border-[#B8BBCA] hover:text-[#0D0F1A]'
        )}
      >
        <Percent className="h-3.5 w-3.5" />
        Margin %
      </button>

      <div className="flex-1" />

      <div className="inline-flex rounded-full bg-[#EDEEF2] p-[3px]">
        {DATE_CHIPS.map((chip) => (
          <button
            key={chip.id}
            type="button"
            onClick={() => onDateChange(chip.id)}
            className={cn(
              'rounded-full px-3.5 py-1.5 text-xs font-semibold transition-all',
              dateFilter === chip.id
                ? 'bg-[#2563EB] text-white'
                : 'bg-transparent text-[#5E6278] hover:text-[#0D0F1A]'
            )}
          >
            {chip.label}
          </button>
        ))}
        <DateRangeModal
          className="rounded-full bg-transparent text-[#5E6278] hover:text-[#0D0F1A]"
          selectedClassName="rounded-full bg-[#2563EB] text-white"
          selectedDate={dateFilter}
          onDateChange={onDateChange}
        />
      </div>
    </div>
  );
}
